const tabs = [
  {
    id: 'top',
    name: 'トップ'
  },
  {
    id: 'amazon-info',
    name: 'Amazon連携設定'
  },
  {
    id: 'multi-channel-service',
    name: 'マルチチャネルサービス'
  },
  {
    id: 'receive-amount-setting',
    name: '受取金額設定'
  }
]

export default tabs



// WEBPACK FOOTER //
// ./src/common/warehouse-amazon-tabs.js